// Components/MessagesArea/components/DateSeparator.jsx
import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

const DateSeparator = ({ date }) => {
    return (
        <Box sx={{ textAlign: 'center', margin: '10px 0', color: '#ddd' }}>
            <Typography variant="body2" sx={{ color: '#ddd', fontSize: '0.9rem' }}>
                {date.toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                })}
            </Typography>
            <Divider sx={{ backgroundColor: '#374045' }} />
        </Box>
    );
};

export default DateSeparator;